import CommonIFrame from 'components/atoms/CommonIFrame';

const AnnualOperatingPlan = () => {
    return (
        <CommonIFrame
            id="annual-operating-plan-iframe"
            src="https://aigehiwhfiwuhaidbaifhdad.lovable.app/"
            title="Annual Operating Plan (AOP)"
        />
    );
};

export default AnnualOperatingPlan;
